<template lang="pug">
.content
  .row
    .col-md-12
      div.box_header
        label.title {{title}}
        label.plus(v-on:click="onItemAdd")
          span(v-on:click="onItemAdd")  Thêm kênh
        label.title-pc {{titleInfo}}
        .clearfix
      div.box-table(v-if="!$isMobile()" style="max-height: 385px; overflow-y: scroll;" v-on:scroll.passive='handleScroll')
        mbTable(:centerColumns="['name', 'action']" @onfilterbyname="filterbyname" :data='channels' :columns='columns' :inlineFilter='true' , v-on:onItemEdit="onItemEdit"  v-on:onItemDelete="onItemDelete")
      div.card.box-channel(v-else)
        .row-header
          span.label-header Tên kênh
          .field-header
            input(@change="filterbynameX($event)" placeholder="Tìm theo tên")
        div.empty-data(v-if='this.channels.length === 0') 
          span Không tìm thấy dữ liệu

        div.list-item(v-else style="overflow-y: scroll;" v-on:scroll.passive='handleScrollX')
          .row-item(v-for='item in channels')
            .row-data
              span.label-header Tên kênh
              .row-value {{item.name}}
            .row-data
              span.label-header Ngày tạo
              .row-value {{formatDate(item.created_at)}}
            .row-data
              span.label-header Ngày cập nhật
              .row-value {{formatDate(item.updated_at)}}
            .row-data
              span.label-header
              .row-value
                small(@click="onItemEdit(item)")
                  img(:src="require('../../assets/images/faces/ic_edit.svg')")
                small(@click="onItemDelete(item)")
                  img(:src="require('../../assets/images/theory/delete-24px.svg')")
</template>
<script>
import gql from 'graphql-tag'
import graphql from '../Model/graphql'
import MdNotification from '@/core/components/mdNotification'
import moment from 'moment'
import mbTable from './mbTable'
import popup from './popup'
import popupDelete from './popupDelete'
export default {
  components: {
    mbTable,
    popup
  },
  data() {
    return {
      message: this.$t('home.comming_soon'),
      limit: 10,
      offset: 0,
      filtername: '',
      MdNotification,
      title: 'Quản lý kênh',
      classesInfo: [],
      titleInfo: '',
      channels: [],
      loader: null,
      columns: [
        { key: 'stt', title: 'STT' },
        { key: 'name', title: 'Tên kênh' },
        { key: 'created_at', title: 'Ngày tạo', type: 'date' },
        { key: 'updated_at', title: 'Ngày cập nhật', type: 'date' },
        { key: 'action', title: '', type: 'action' }
      ]
    }
  },
  mounted () {
    if (this.$route.params.reload === 1) {
      console.log('reload')
      this.$apollo.queries.channels.refresh()
    }
  },
  watch: {
    '$route': function(from, to) {
      if (from !== to) this.$apollo.queries.channels.refresh()
    }
  },
  methods: {
    showNotification(message, color, from, align, timeout) {
      this.$notifications.notify({
        type: color,
        icon: 'notifications',
        message: message,
        placement: {
          from,
          align
        },
        timeout: timeout
      })
    },
    formatDate(value) {
      return moment(value).format('DD/MM/YYYY - hh:mm')
    },
    onItemAdd() {
      this.$modal.show(popup, {saveChannel: this.saveChannel, classes_id: Number(this.$route.query.id)}, {
        clickToClose: false,
        height: 'auto',
        adaptive: true,
        classes: ['col-md-6'],
        reset: true
      })
    },
    show() {
      this.loader = this.$loading.show({
        color: '#ffffff',
        loader: 'spinner',
        width: 60,
        height: 60,
        backgroundColor: '#000000',
        opacity: 0.5,
        zIndex: 9999,
        canCancel: false
      })
    },
    async saveChannel(returnData) {
      this.show()
      if (returnData.dataInput.item !== undefined && returnData.dataInput.item !== null) {
        this.$apollo.mutate({
          mutation: gql(graphql.UPDATE_CHANNEL),
          variables: {
            objInput: {
              name: returnData.dataInput.name,
              updated_by: this.$store.getters.user
            },
            objWhere: {
              classes_id: {_eq: Number(this.$route.query.id)},
              id: {_eq: returnData.dataInput.item.id}
            }
          },
          update: (store, { data: { update_channel } }) => {
          }
        }).then((data) => {
          this.loader.hide()
          this.$apollo.queries.channels.refetch()
          this.showNotification('Cập nhật kênh ' + returnData.dataInput.name + ' thành công', 'warning', 'top', 'right', 7000)
          this.$modal.hide('dialog')
        }).catch((error) => {
          this.loader.hide()
          console.error(error)
        })
      } else {
        var variables = {
          name: returnData.dataInput.name,
          is_delete: false,
          private: false,
          created_by: this.$store.getters.user,
          classes_id: Number(this.$route.query.id)
        }
        this.$apollo.mutate({
          mutation: gql(graphql.CREATE_CHANNEL),
          variables: {
            objInput: variables
          },
          update: (store, { data: { insert_channel } }) => {
          }
        }).then((data) => {
          this.loader.hide()
          this.showNotification('Tạo mới kênh ' + returnData.dataInput.name + ' thành công', 'warning', 'top', 'right', 7000)
          this.$apollo.queries.channels.refetch()
          this.$modal.hide('dialog')
        }).catch((error) => {
          this.loader.hide()
          console.error(error)
        })
      }
    },
    onItemEdit(payload) {
      this.$modal.show(popup, {saveChannel: this.saveChannel, classes_id: Number(this.$route.query.id), isFinish: this.isFinish, item: payload}, {
        clickToClose: false,
        height: 'auto',
        adaptive: true,
        classes: ['col-md-6'],
        reset: true
      })
    },
    onItemDelete(payload) {
      // console.log(payload)
      this.$modal.show(popupDelete, {
        id: payload.id,
        name: payload.name,
        saveFunction: this.onItemDeleteParent
      }, {
        height: 'auto',
        classes: ['col-6'],
        adaptive: true,
        clickToClose: false
      })
    },
    async onItemDeleteParent(payload) {
      await this.$apollo.mutate({
        mutation: gql(graphql.UPDATE_CHANNEL),
        variables: {
          objInput: {
            is_delete: true,
            updated_by: this.$store.getters.user
          },
          objWhere: {
            classes_id: {_eq: payload.classes_id},
            id: {_eq: payload.id}
          }
        }
      }).then((data) => {
        this.showNotification('Kênh đã bị xóa', 'warning', 'top', 'right', 7000)
        this.$apollo.queries.channels.refetch()
      }).catch((error) => {
        // Error
        console.error(error)
      })
    },
    handleScroll: function(e) {
      if ((e.target.scrollHeight - 385) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 385) === Math.floor(e.target.scrollTop)) {
        this.limit = this.channels.length + 10
      }
    },
    handleScrollX: function(e) {
      if ((e.target.scrollHeight - 538) === Math.round(e.target.scrollTop) || (e.target.scrollHeight - 538) === Math.floor(e.target.scrollTop)) {
        this.limit = this.channels.length + 5
      }
    },
    filterbyname(valueName) {
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.$apollo.queries.channels.refetch()
    },
    filterbynameX(event) {
      var valueName = event.target.value
      this.filtername = ''
      if (valueName !== '') {
        this.filtername = valueName
      }
      this.$apollo.queries.channels.refetch()
    }
  },
  async created () {
    var objWhere = {
      id: {_eq: Number(this.$route.query.id)}
    }
    const {data} = await this.$apollo.query({
      query: gql(graphql.GET_CLASSES_GRADE_PC),
      variables: { where: objWhere }
    })
    if (data.classes && data.classes.length > 0) {
      this.classesInfo = data.classes[0]
      this.titleInfo = this.classesInfo.private_community.name + ' / ' + this.classesInfo.name + ' / ' + this.title
    }
  },
  apollo: {
    channels: {
      query: gql(graphql.GET_CHANNEL),
      fetchPolicy: 'no-cache',
      variables() {
        var objWhere = {
          classes_id: {_eq: Number(this.$route.query.id)},
          is_delete: {_eq: false}
        }
        if (this.filtername !== '') {
          objWhere = Object.assign(objWhere, {name: {_ilike: '%' + this.filtername + '%'}})
        }
        let variables = {
          where: objWhere,
          order_by: {
            private: 'desc',
            created_at: 'desc',
            name: 'asc'
          },
          limit: 10
        }
        return variables
      },
      update: data => {
        return data.channel
      },
      error(error) {
        if (error.graphQLErrors[0].extensions.code === 'invalid-jwt') {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>

<style lang="scss">
.box_header{
  label.title{text-align: left;  font-size:20px;font-weight:bold;font-family: 'adobe-clean', sans-serif; letter-spacing: 0px;color: #5F6468;display:inline-block}
  label{
    &.title-pc{display: block;margin-top: 10px;color: #343A40; font-size: 16px;}
    &.plus{background: #FFD311 0% 0% no-repeat padding-box;border-radius: 5px;padding: 12px 40px; cursor: pointer; float: right;
      span{color: #23180A;}
    }
    &.minus{ background: #FFD311 0% 0% no-repeat padding-box;border-radius: 5px;padding: 12px 40px; float: left; cursor: pointer;}
  }
}
.box-table{ background: #FFFFFF 0% 0% no-repeat padding-box;box-shadow: 0px 1px 3px #00000029;padding:10px;margin-top:20px;border-radius: 10px;
  .table{margin-bottom: 0;}
}
.box-popup-confirm{box-shadow: 0px 3px 6px #00000029; border-radius: 10px !important;
  .dialog-content{ padding: 0;
    .dialog-c-title {text-transform: uppercase; text-align: left;font-size:17px; font-family: Helvetica;letter-spacing: 0px;color: #343A40; border-bottom: 1px solid #DFE2E6; padding: 12px 15px 15px; font-weight: bold; margin-bottom: 15px;}
    .dialog-c-text{padding: 0 15px;}
  }
  .vue-dialog-buttons {justify-content: center;display: flex; border: 0! important; margin-top: 30px; margin-bottom: 5px;
    .confirm-delete-dialog {background: #FFD311 0% 0% no-repeat padding-box! important;border-radius: 5px; width: 160px;color: #23180A! important;margin-right: 10px;flex: unset! important;}
    .cancel-delete-dialog, .cancel-delete-dialog:hover {background: #FFFFFF 0% 0% no-repeat padding-box! important;border: 1px solid #FFD311;border-radius: 5px;width: 160px;color: #23180A! important;flex: unset! important;}
  }
}
@media screen and (max-width: 991px){
  .box-channel{background: #FFFFFF 0% 0% no-repeat padding-box; box-shadow: 0px 1px 2px #00000029; padding: 15px;
    .row-header{border: 1px solid #E0E0E0;border-top: 0;background: #FAFAFA 0% 0% no-repeat padding-box; 
      .label-header{display: inline-block; line-height: 30px;width: 40%;font-weight: bold;text-align: right; padding-right: 10px;}
      .field-header{padding: 3px 10px; display: inline-block; width: 60%; background: #EAEAEA 0% 0% no-repeat padding-box;
        input, select{width: 100%;border-radius: 10px; padding: 3px 10px; background: #fff;border: 1px solid #B4B4B4;}
      }
      &:first-child{border-top: 1px solid #E0E0E0;}
    }
    .empty-data{margin-top: 20px; background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px; text-align: center; padding: 5px;}
    .list-item{margin-top: 20px;
      .row-item{background: #FAFAFA 0% 0% no-repeat padding-box;border: 1px solid #E0E0E0;border-radius: 5px; padding: 7px 5px;
        &:first-child{margin-bottom: 10px;}
        .row-data{
          .label-header{display: inline-block; width: 40%;font-weight: bold;text-align: left;}
          .row-value{padding: 3px 0; display: inline-block; width: 60%;
            &.title{font-size: 15px; font-weight: bold; margin-bottom: 15px;display: block;}
            &.link{text-decoration: underline; color:#554BC1;}
            select{background: #FFFFFF 0% 0% no-repeat padding-box; border: 1px solid #B4B4B4; border-radius: 5px; opacity: 1; padding: 6px;width: 100%;}
            small{margin-right: 10px; float: left;
              &:last-child{margin-right: 0;}
              img{width: 16px;height: 16px;}
            }
            img.img{border-radius: 50%;width: 30px; height: 30px;}
          }
        }
      }
    }
  }
}
@media screen and (max-width: 768px){
  
}
</style>



// WEBPACK FOOTER //
// index.vue?ac45875a